export default "__VITE_ASSET__03ade7e4__"